import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {ConstantProvider} from '../../../_services/constants.service';
import {MapProvider} from '../../../_services/map';
import {ModalController} from '@ionic/angular';
import {SearchLocationComponent} from '../../../components/search-location/search-location.component';
import {MapFilterComponent} from './map-filter/map-filter.component';
import {ToastService} from '../../../_services/toast.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {CommonService} from '../../../_services/common.service';
import {OnEnter} from '../../../_interface/on.enter';
import {Observable, Subscription} from 'rxjs';
import {Capacitor} from '@capacitor/core';
import {Geolocation} from '@capacitor/geolocation';
import {DetectLocationComponent} from '../../../components/detect-location/detect-location.component';
import {LocalStorageService, UserService} from '../../../_services';
import {MenuOptionsModalPage} from '../../../components/menu-options-modal/menu-options-modal-page';
import {DeleteReportComponent} from '../../../components/delete-report/delete-report.component';

// import {Diagnostic} from '@awesome-cordova-plugins/diagnostic/ngx';


declare let google;

@Component({
  selector: 'app-why-ic-map-landing',
  templateUrl: './map-landing.component.html',
  styleUrls: ['./map-landing.component.scss']
})

export class MapLandingComponent implements OnInit, OnEnter, OnDestroy {
  // @ViewChild('map') mapElement: ElementRef<HTMLInputElement>;
  @ViewChild('map', {static: true}) mapElement: ElementRef;
  toggled: boolean;
  map: any;
  public address = '';
  public minDistance = 1000;
  public selectedLocation: any = {};
  public coordinates: any = {};
  public marker;
  public emotions = [];
  isClusterClick = false;
  public filterData = {emotions: [], ages: [], genders: [], categoryList: [], organisationSize: [], operationTime: []};
  projectObj: any;
  lastProject = '';
  public selectedLocationObj: any;
  reportObj: any = {};
  testValue = '';
  displayActionButton = true;
  eventType = '';
  emotionSubscription: any;
  emotionClosedSubscription: any;
  isAddReport = false;
  subscription: Subscription;
  filterSet = null;
  displayMessage = true;
  myLocation = 'Detect my location';
  dialogOpen = false;

  constructor(private constants: ConstantProvider,
              private modalController: ModalController,
              private toast: ToastService,
              private commonService: CommonService,
              private ref: ChangeDetectorRef,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private userService: UserService,
              private localStorage: LocalStorageService,
              public mapService: MapProvider) {
    if (this.router.url.includes('/add-report')) {
      this.isAddReport = true;
    }
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.lat && params.lng) {
        console.log(params);
        const pos = new google.maps.LatLng(params.lat, params.lng);
        this.setMapView(pos);
        if (params.hasOwnProperty('projectType')) {
          this.projectObj = this.commonService.getProjectDetails(params.projectType);
          this.localStorage.set('projectType', params.projectType);
        } else {
          this.localStorage.set('projectType', 'ap');
          this.projectObj = this.commonService.getProjectDetails('ap');
        }
        setTimeout(() => {
          this.displayMarkerAtCurrentPosition(pos);
        }, 10);
        this.router.navigate(
          [],
          {
            relativeTo: this.activatedRoute,
            queryParams: {code: null},
            queryParamsHandling: 'merge', // remove to replace all query params by provided
          });
        this.router.navigate(['/map']);
      }
      if (params.hasOwnProperty('projectType')) {
        this.projectObj = this.commonService.getProjectDetails(params.projectType);
        this.localStorage.set('projectType', params.projectType);
        this.router.navigate(
          [],
          {
            relativeTo: this.activatedRoute,
            queryParams: {code: null},
            queryParamsHandling: 'merge', // remove to replace all query params by provided
          });
        this.router.navigate(['/map']);
      }
    });
  }

  checkSearchBar() {
    if (this.toggled) {
      this.toggled = !this.toggled;
    }
  }

  addReport() {
    this.mapService.moveToLocation(this.selectedLocationObj.lat, this.selectedLocationObj.lng);
    this.displayMarkerAtCurrentPosition({lat: this.selectedLocationObj.lat, lng: this.selectedLocationObj.lng});
  }

  addNewReport() {
    if (this.projectObj.ref === 'ap') {
      this.lastProject = 'ap';
      this.selectProject();
    } else {
      if (this.projectObj.ref === 'act' || this.projectObj.ref === 'space') {
        this.router.navigate(['./your-act-add-report'], {queryParams: this.reportObj});
      } else {
        this.router.navigate(['./add-report'], {queryParams: this.reportObj});
      }
    }
  }

  async ngOnInit() {
    this.emotionSubscription = this.mapService.emotionSelectedEmitter()
      .subscribe(item => this.selectedEmotion(item));

    this.emotionClosedSubscription = this.mapService.emotionClosedEmitter()
      .subscribe(() => {
        this.displayActionButton = true;
      });
    this.subscription = this.router.events.subscribe(async (event: any) => {
      if (event instanceof NavigationEnd && event.url === '/map') {
        await this.onEnter();
      }
    });
    const tempObj = JSON.parse(sessionStorage.getItem('filter_data'));
    if (tempObj !== null) {
      this.filterSet = 'set';
    }
  }

  selectedEmotion(emotionObj: any) {
    this.reportObj = emotionObj;
    this.reportObj.reportDetails = true;
    this.reportObj.viewReport = true;
    this.displayActionButton = false;
    this.eventType = 'report';
    this.displayMessage = false;
  }

  public initMap() {
    const styledMapType = new google.maps.StyledMapType(this.constants.mapStyle, {name: 'Styled Map'});
    const mapCenter = this.constants.mapCenter;
    const viewAllValue = true;
    this.map = new google.maps.Map(this.mapElement.nativeElement, {
      zoom: this.constants.currentLocationZoomLevel,
      center: mapCenter,
      minimumClusterSize: 10,
      clickableIcons: false,
      disableDefaultUI: true, // a way to quickly hide all controls
      zoomControl: false,
    });

    //Associate the styled map with the MapTypeId and set it to display.
    this.map.mapTypes.set('styled_map', styledMapType);
    this.map.setMapTypeId('styled_map');

    this.mapService.initializeMapObject(this.map, viewAllValue);
    this.getLocation();

    google.maps.event.addListenerOnce(this.map, 'idle', () => {
      if (this.map.getZoom() > 16) {
        this.map.setZoom(this.constants.currentLocationZoomLevel);
      }
    });

    google.maps.event.addListener(this.map, 'click', () => {
      this.displayMessage = false;
    });

    google.maps.event.addListener(this.map, 'clusterclick', () => {
      this.isClusterClick = true;
    });

    google.maps.event.addListener(this.map, 'click', (event) => {
      if (!this.displayMessage && !this.displayActionButton) {
        this.displayMessage = !this.displayMessage;
        this.displayActionButton = !this.displayActionButton;
      } else if (this.address === '' && !this.isClusterClick) {
        this.displayMarkerAtCurrentPosition(event.latLng);
        this.updateCoordinates(event, 'drop');
        this.map.setZoom(this.constants.currentLocationZoomLevel);
        this.eventType = 'newReport';
      } else {
        this.address = '';
        this.eventType = 'report';
        this.displayMessage = true;
        this.isClusterClick = false;
      }
    });
  }

  async onEnter(): Promise<void> {
    this.mapService.currentUserLocation = [];
    this.initMap();
    this.setMapView();
    this.getEvents();
  }

  getEvents() {
    const projectType = localStorage.getItem('projectType');
    if (projectType === 'globalYarning') {
      this.userService.getEvent(projectType)
        .subscribe({
          next: value => {
            console.log(value);
            this.reportObj = value[0];
            this.reportObj.reportDetails = true;
            this.reportObj.viewReport = true;
            this.displayActionButton = false;
            this.eventType = 'report';
            this.displayMessage = false;
          },
        });
    }
  }

  async setMapView(pos?: any) {
    const projectType = localStorage.getItem('projectType');
    this.projectObj = this.commonService.getProjectDetails(projectType);
    this.mapService.initializeMapObject(this.map, true);
    await this.mapService.getLocation();
    if (pos === undefined) {
      await this.getMyLocation();
    }
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getLocation() {
    if (this.marker) {
      this.marker.setMap(null);
      this.marker = undefined;
    }

    if (localStorage.getItem('viewDetailLocation')) {
      const location = JSON.parse(localStorage.getItem('viewDetailLocation'));
      const loc = {lat: location[1], lng: location[0]};
      this.displayMarkerAtCurrentPosition(loc);
      this.minDistance = 1000;
      const event: any = {};

      event.latLng = {};

      event.latLng.lat = () => location[1];
      event.latLng.lng = () => location[0];

      // this.updateCoordinates(event);
      localStorage.removeItem('viewDetailLocation');
    }
  }

  /**
   * Displays marker at user's current location
   */
  public displayMarkerAtCurrentPosition(pos = null) {

    const bounds: any = new google.maps.LatLngBounds();
    let markerLocation: any;
    if (pos) {
      markerLocation = pos;
    }

    //icon for marker
    const currentLocationMarker: any = {
      url: 'assets/icon/pin.svg', // url
      scaledSize: new google.maps.Size(60, 60), // scaled size
    };

    if (this.marker) {
      this.marker.setMap(null);
    }

    this.marker = new google.maps.Marker({
      draggable: true,
      position: markerLocation,
      icon: currentLocationMarker,
      map: this.map,
      zIndex: 9999
    });

    google.maps.event.addListener(this.marker, 'dragend', this.updateCoordinates.bind(this));

    //extend the bounds to include each marker's position
    bounds.extend(this.marker.position);

    // Commented based on call with taire
    //now fit the map to the newly inclusive bounds
    this.map.fitBounds(bounds);
    this.map.setZoom(this.constants.currentLocationZoomLevel);
    if (this.selectedLocationObj) {
      this.address = this.selectedLocationObj.address;
      this.reportObj.name = this.selectedLocationObj.name;
      this.reportObj.title = this.selectedLocationObj.title;
      this.reportObj.address = this.selectedLocationObj.address;
      this.reportObj.location = [markerLocation.lng, markerLocation.lat];
      this.reportObj.reportDetails = true;
      this.reportObj.viewReport = false;
      this.reportObj.addReport = true;
      this.displayActionButton = false;
    }
  }

  public updateCoordinates(event, type?) {
    this.displayMessage = false;
    this.minDistance = 1000;
    const location = new google.maps.LatLng(event.latLng.lat(), event.latLng.lng());
    if (type) {
      this.mapService.currentUserLocation[0] = event.latLng.lat();
      this.mapService.currentUserLocation[1] = event.latLng.lng();
    }
    this.coordinates = {lat: event.latLng.lat(), lng: event.latLng.lng()};
    this.getAddress(location);
  }

  getUserLocation(position) {
    const loc = new google.maps.LatLng(position.lat, position.lng);
    new google.maps.Geocoder().geocode({location: loc}, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results[1]) {
          let city = results[1].address_components.find((obj) => obj.types.includes('locality'));
          city = city ? city.long_name : '';
          let state = results[1].address_components.find((obj) => obj.types.includes('administrative_area_level_1'));
          state = state.long_name;
          this.myLocation = city === '' ? state : city + ', ' + state;
        }
      }
    });
  }

  /**
   * Function to get address using lat,lng values
   *
   * @param location - contains lat lng values
   */
  public getAddress(location) {
    const self = this;
    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    new google.maps.Geocoder().geocode({location}, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results[1]) {
          let city = results[1].address_components.find((obj) => obj.types.includes('locality'));
          city = city ? city.long_name : '';
          let state = results[1].address_components.find((obj) => obj.types.includes('administrative_area_level_1'));
          state = state.short_name;

          self.selectedLocation.title = city === '' ? state : city + ', ' + state;
          self.selectedLocation.location = results[1].formatted_address;
          self.selectedLocation.address = results[1].formatted_address;

          localStorage.setItem('userLocation', JSON.stringify(results[1].formatted_address));

          localStorage.setItem('userLocation', JSON.stringify(self.selectedLocation.location));
          localStorage.setItem('userAddress', self.selectedLocation.address);
          localStorage.setItem('locationName', self.selectedLocation.name);
          self.address = self.selectedLocation.name + ', ' + self.selectedLocation.address;
          self.testValue = 'hi';

          self.setReport({
            name: self.selectedLocation.name,
            title: self.selectedLocation.title,
            address: self.selectedLocation.address,
            location: [self.coordinates.lng, self.coordinates.lat],
            addReport: true,
          });
        }

        if (!self.marker) {
          self.displayMarkerAtCurrentPosition();
        }
      }
    });
  }


  setReport(obj) {
    const self = this;
    self.eventType = 'newReport';
    self.reportObj = obj;
    self.displayActionButton = false;
    self.ref.detectChanges();
  }


  async popUpSearchContainer() {
    const searchBy = this.selectedLocationObj === undefined ? '' : this.selectedLocationObj.name;
    const modal = await this.modalController.create({
      component: SearchLocationComponent,
      cssClass: 'custom-modal',
      showBackdrop: true,
      backdropDismiss: true,
      componentProps: {
        searchBy
      }
    });
    modal.onDidDismiss()
      .then((dataObj: any) => {
        if (dataObj.data) {
          this.selectedLocationObj = dataObj.data.selectedLocationObj;
          if (this.selectedLocationObj.lat && this.selectedLocationObj.lng) {
            this.mapService.moveToLocation(this.selectedLocationObj.lat, this.selectedLocationObj.lng);
            const loc = {lat: this.selectedLocationObj.lat, lng: this.selectedLocationObj.lng};
            this.mapService.currentUserLocation[0] = this.selectedLocationObj.lat;
            this.mapService.currentUserLocation[1] = this.selectedLocationObj.lng;
            this.displayMessage = false;
            this.eventType = 'newReport';
            this.displayMarkerAtCurrentPosition(loc);
            this.map.setZoom(this.constants.currentLocationZoomLevel);
          }
        }
      });
    return await modal.present();
  }


  async filter() {
    this.filterData = JSON.parse(sessionStorage.getItem('filter_data'));
    if (this.filterData === null) {
      this.filterData = {
        emotions: [],
        ages: [],
        genders: [],
        categoryList: [],
        organisationSize: [],
        operationTime: []
      };
    }
    if (this.reportObj.hasOwnProperty('_id')) {
      return;
    }
    const modal: any = await this.modalController.create({
      component: MapFilterComponent,
      componentProps: {
        selectProjectMap: true,
        emotions: this.filterData.emotions,
        ages: this.filterData.ages,
        selectedCategoryList: this.filterData.categoryList,
        selectedOrganisationSize: this.filterData.organisationSize,
        genders: this.filterData.genders
      },
      cssClass: 'custom-modal',
      showBackdrop: true,
      backdropDismiss: true,
    });

    modal.onDidDismiss()
      .then((data) => {
        if (data.data && Object.keys(data.data).length > 0) {
          // this.filterData = data.data;
          this.filterData = data.data;
          let emotionList = '';
          let genderList = '';
          let categoryList = '';
          let organisationSizeList = '';
          let operationTimeList = '';
          this.filterData.emotions.forEach((emotions, index) => {
            if (index === 0) {
              emotionList = emotions.name;
            } else {
              emotionList = emotionList + ',' + emotions.name;
            }
          });

          this.filterData.categoryList.forEach((emotions, index) => {
            if (index === 0) {
              categoryList = encodeURIComponent(emotions);
            } else {
              categoryList = categoryList + ',' + encodeURIComponent(emotions);
            }
          });

          console.log(this.filterData);
          this.filterData.organisationSize.forEach((emotions, index) => {
            if (index === 0) {
              organisationSizeList = encodeURIComponent(emotions);
            } else {
              organisationSizeList = organisationSizeList + ',' + encodeURIComponent(emotions);
            }
          });

          console.log(this.filterData.operationTime);
          this.filterData.operationTime.forEach((emotions, index) => {
            if (index === 0) {
              operationTimeList = encodeURIComponent(emotions);
            } else {
              operationTimeList = operationTimeList + ',' + encodeURIComponent(emotions);
            }
          });

          this.filterData.genders.forEach((gender, index) => {
            if (index === 0) {
              genderList = gender;
            } else {
              genderList = genderList + ',' + gender;
            }
          });
          this.filterSet = 'set';
          sessionStorage.setItem('filter_data', JSON.stringify(this.filterData));
          sessionStorage.setItem('filter_emotion', JSON.stringify(emotionList));
          sessionStorage.setItem('filter_gender', JSON.stringify(genderList));
          sessionStorage.setItem('filter_category', JSON.stringify(categoryList));
          sessionStorage.setItem('filter_operationTime', JSON.stringify(operationTimeList));
          sessionStorage.setItem('filter_organisationSize', JSON.stringify(organisationSizeList));
          this.setMapView();
          this.initMap();
          setTimeout(() => {
            this.mapService.moveToLocation(this.mapService.currentUserLocation[0], this.mapService.currentUserLocation[1]);
            this.displayMarkerAtCurrentPosition({
              lat: this.mapService.currentUserLocation[0],
              lng: this.mapService.currentUserLocation[1]
            });
          }, 50);
        } else {
          if (this.filterSet === 'set') {
            this.setMapView();
            this.initMap();
            setTimeout(() => {
              this.mapService.moveToLocation(this.mapService.currentUserLocation[0], this.mapService.currentUserLocation[1]);
              this.displayMarkerAtCurrentPosition({
                lat: this.mapService.currentUserLocation[0],
                lng: this.mapService.currentUserLocation[1]
              });
            }, 50);
          }
          this.filterSet = null;
        }
      });
    return await modal.present();
  }

  async selectProject() {
    this.displayActionButton = !this.displayActionButton;
    this.displayMessage = !this.displayMessage;
    this.router.navigate(['./'], {queryParams: {projectType: this.projectObj.ref}});
  }


  async getMyLocation(type?: string) {
    if (type === 'pos') {
      this.mapService.currentUserLocation = [];
    }
    if (Capacitor.getPlatform() === 'ios' || Capacitor.getPlatform() === 'android') {
      try {
        const checkPermission = await Geolocation.checkPermissions();
        if (checkPermission.coarseLocation !== 'denied' || checkPermission.location !== 'denied') {
          const coordinates = await Geolocation.getCurrentPosition();
          if (coordinates) {
            this.mapService.moveToLocation(coordinates.coords.latitude, coordinates.coords.longitude);
            this.getUserLocation({lat: coordinates.coords.latitude, lng: coordinates.coords.longitude});
            this.displayMarkerAtCurrentPosition({
              lat: coordinates.coords.latitude,
              lng: coordinates.coords.longitude
            });
          } else {
            this.defaultPosition();
          }
        } else {
          this.defaultPosition();
        }
      } catch (e) {
        console.error(e, 'checkPermissions error');
        this.defaultPosition();
      }
    } else {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition.bind(this), this.defaultPosition.bind(this));
      }
    }
    this.defaultLocationFun();
  }

  defaultLocationFun() {
    this.displayActionButton = true;
    this.selectedLocationObj = undefined;
  }

  showPosition(position: any) {
    const loc: any = {lat: position.coords.latitude, lng: position.coords.longitude};
    this.displayMarkerAtCurrentPosition(loc);
    this.mapService.moveToLocation(position.coords.latitude, position.coords.longitude);
    this.getUserLocation(loc);
  }

  defaultPosition(event?: any) {
    if (event === undefined || (event && event.PERMISSION_DENIED === 1)) {
      this.detectLocation();
      this.myLocation = 'Detect my location';
    }
    if (this.projectObj.ref === 'globalYarning') {
      this.mapService.moveToLocation(this.constants.yarningDefaultLocation.lat, this.constants.yarningDefaultLocation.lng);
    } else {
      this.displayMarkerAtCurrentPosition({
        lat: this.constants.defaultLocation.lat,
        lng: this.constants.defaultLocation.lng
      });
      this.mapService.moveToLocation(this.constants.addReportDefaultLocation.lat, this.constants.addReportDefaultLocation.lng);
    }
    this.map.setZoom(this.constants.currentLocationZoomLevel);
  }

  async detectLocation() {
    if (!this.dialogOpen && this.projectObj.ref !== 'space') {
      this.dialogOpen = true;
      const modal = await this.modalController.create({
        component: DetectLocationComponent,
        cssClass: 'pop-up-modal',
        showBackdrop: true,
        backdropDismiss: true,
      });
      modal.onDidDismiss()
        .then(() => {
          this.dialogOpen = false;
        });
      return await modal.present();
    }
  }

  async openMenu() {
    const modal = await this.modalController.create({
      component: MenuOptionsModalPage,
      componentProps: {
        projectType: this.projectObj
      },
      cssClass: 'custom-menu',
      showBackdrop: true,
      backdropDismiss: true,
    });
    return await modal.present();
  }

  setFlags() {
    this.displayActionButton = true;
    this.displayMessage = true;
  }
}

